import ViewModelCore from "./ViewModel";

export default class GerarNovoPedidoCaracteristicasViewModel extends ViewModelCore{
	constructor () {
        super();
		this.Id = undefined;
		this.OrcamentoId = undefined;
		this.PedidoId = undefined;
		this.ImpressaoAmostra = undefined;
		this.ImpressaoProvaDeCores = undefined;
		this.ImpressaoEmpresa = undefined;
		this.ImpressaoNumeroDoProduto = undefined;
		this.ImpressaoProvaDeCoresConfeccionar = undefined;
		this.ImpressaoPantone = undefined;
		this.ImpressaoNumeroPantone = undefined;
		this.ImpressaoTemOutros = undefined;
		this.ImpressaoOutros = undefined;
		this.ImpressaoDescricao = undefined;
		this.VisualAmostra = undefined;
		this.VisaulArquivo = undefined;
		this.VisualArquivoDescricao = undefined;
		this.VisualEmpresa = undefined;
		this.VisualNumeroDoProduto = undefined;
		this.VisualTemOutros = undefined;
		this.DescricaoVisualOutros = undefined;
		this.DescricaoVisual = undefined;
		this.FacaSistemaAmostra = undefined;
		this.FacaSistemaRiscoDeFaca = undefined;
		this.FacaSistemaPlanta = undefined;
		this.FacaSistemaPrototipo = undefined;
		this.FacaSistemaPrototipoDescricao = undefined;
		this.FacaSistemaEmpresa = undefined;
		this.CodigoFacaSistemaProduto = undefined;
		this.FacaSistemaTemOutros = undefined;
		this.FacaSistemaOutros = undefined;
		this.FacaSistemaDescricao = undefined;
		this.FacaMedidaAmostra = undefined;
		this.FacaMedidaPlanta = undefined;
		this.FacaMedidaEmpresa = undefined;
		this.CodigoFacaMedidaProduto = undefined;
		this.FacaMedidaRiscoDeFaca = undefined;
		this.FacaMedidaPrototipo = undefined;
		this.FacaMedidaPrototipoDescricao = undefined;
		this.FacaMedidaTemOutros = undefined;
		this.FacaMedidaDescricao = undefined;
		this.FacaMedidaOutros = undefined;
		this.TipoFluxoOrcamento = undefined;
		this.ProgramacaoKanban = undefined;
		this.ObservacaoGeral = undefined;
		this.StatusPedidoTexto = undefined;
		this.ImpressaoProdutoId = undefined;
		this.VisualProdutoId = undefined;
		this.FacaSistemaProdutoId = undefined;
		this.FacaMedidaProdutoId = undefined;
		this.ImpressaoProduto = undefined;
		this.VisualProduto = undefined;
		this.FacaSistemaProduto = undefined;
		this.FacaMedidaProduto = undefined;
		this.LocalFSC = undefined;
		this.ObservacaoFSC = undefined;

	}
}